export default __webpack_public_path__ + "static/media/simple-logo.ff90ca16.jpg";